// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyArcQPoHMgI5Eo8ga-ZFYd82cku3gsirhM",
  authDomain: "instantdm-a8b09.firebaseapp.com",
  projectId: "instantdm-a8b09",
  storageBucket: "instantdm-a8b09.firebasestorage.app",
  messagingSenderId: "796338025326",
  appId: "1:796338025326:web:fbf1b188cf7d0ecafcc77f",
  measurementId: "G-JTED4VNJFV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const fireANALYTICS = getAnalytics(app);
const fireAUTH = getAuth(app);
const fireDB = getFirestore(app);
const fireSTORAGE = getStorage(app);

export { fireANALYTICS, fireAUTH, fireDB, fireSTORAGE };